import { BaseModel, PaginationDataModel, convertToArrayModels, convertToModel, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import type { PaginationData } from '~/shared/interfaces'
import ResearchShowcaseCard from './ResearchShowcaseCard'

export default class ResearchShowcaseQueryResult extends BaseModel {
  static override constructorName = 'ResearchShowcaseQueryResult'

  items: ResearchShowcaseCard[] = []
  pagination: PaginationData = new PaginationDataModel()

  constructor(data?: unknown) {
    super(data)
    if (!isUnknownObject(data)) return

    this.items = convertToArrayModels(data.data, ResearchShowcaseCard)

    this.pagination = convertToModel(data.meta, PaginationDataModel, this.pagination)
  }
}

registerModel(ResearchShowcaseQueryResult)
